import { render, staticRenderFns } from "./settings-account-main.vue?vue&type=template&id=0941a145&"
import script from "./settings-account-main.vue?vue&type=script&lang=js&"
export * from "./settings-account-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports